import { render } from "./EmptyState.vue?vue&type=template&id=f6b38116&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"

import "../../assets/scss/empty_state.scss?vue&type=style&index=0&id=f6b38116&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b38116"]])

export default __exports__